import React from 'react';

interface OnlineIndicatorProps {
    size?: number;
    className?: string;
}

export const OnlineIndicator: React.FC<OnlineIndicatorProps> = ({
    size = 10,
    className = '',
}) => (
    <span
        className={`rounded-full bg-green-500 ${className}`}
        style={{
            width: size,
            height: size,
            display: 'inline-block',
            boxShadow: '0 0 0 2px white, 0 0 0 3px #22c55e',
        }}
    />
);

export const OnlineIndicatorBox: React.FC = () => (
    <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75"></span>
        <span className="relative inline-flex h-3 w-3 rounded-full bg-green-500"></span>
    </span>
);

// New profile indicator component
export const NewIndicator: React.FC = () => (
    <span className="relative flex h-3 w-3">
        <span className="relative inline-flex h-3 w-3 rounded-full bg-blue-500"></span>
    </span>
);
